import camelCase from 'lodash/camelCase'
import React from 'react'

import { ResponsiveCardBase } from '../ResponsiveCardBase/ResponsiveCardBase'

import healthConnectExerciseTypes from './healthConnectExerciseTypes'
import healthKitExerciseTypes from './healthKitExerciseTypes'

import { CardIconButton } from 'Components/IconButton'
import { buildCdnImageUrl } from 'Config'
import getSyncedEnergyMotionRecordSource from 'Pages/JournalPage/utils/getSyncedEnergyMotionRecordSource'
import { Formatter } from 'Utils'

export interface EnergyMotionRecord {
  description: string
  energy: number
  duration: number
  source?: string
  hidden?: boolean
}

type Props = {
  energyMotionRecord: EnergyMotionRecord
  iconButtons: CardIconButton[]
  cardButtons: JSX.Element[]
}

export const JournalCardEnergyMotion: React.FC<Props> = ({
  energyMotionRecord: { description, energy, duration, source, hidden },
  ...responsiveCardBaseProps
}: Props) => {
  const isSyncedRecord = getSyncedEnergyMotionRecordSource(source) !== 'none'

  const getTitle = (source: string): string | undefined => {
    switch (source) {
      case 'google-health-connect':
        return healthConnectExerciseTypes[description as keyof typeof healthConnectExerciseTypes]

      case 'apple-health-kit':
        return healthKitExerciseTypes[camelCase(description) as keyof typeof healthKitExerciseTypes]

      default:
        return description
    }
  }

  return (
    <ResponsiveCardBase
      title={getTitle(getSyncedEnergyMotionRecordSource(source))}
      details={Formatter.formatEnergy(energy) + ' / ' + Formatter.formatDuration(duration)}
      className="is-motion"
      imageUrl={isSyncedRecord ? buildCdnImageUrl('standardcard-synced-motion.png') : null}
      hidden={hidden}
      {...responsiveCardBaseProps}
    />
  )
}
